import { render, staticRenderFns } from "./DashboradActionsToTake.vue?vue&type=template&id=48ec2cba"
import script from "./DashboradActionsToTake.vue?vue&type=script&lang=js"
export * from "./DashboradActionsToTake.vue?vue&type=script&lang=js"
import style0 from "./DashboradActionsToTake.vue?vue&type=style&index=0&id=48ec2cba&prod&lang=scss"
import style1 from "./DashboradActionsToTake.vue?vue&type=style&index=1&id=48ec2cba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports